import React, { useRef, useState } from "react";
import { CustomModal } from "../../components/styledComponent/styledModal";
import { StyledButton } from "../../components/styledComponent/styledElements";
import { Col, Divider, Form, Row, Upload } from "antd";
import { PiUploadSimpleLight } from "react-icons/pi";
import { uploadBanner } from "../../server/bannerServices";
import { ShowNotification } from "../../components/notification/notification";
import ImagePreview from "../../components/preview/imagePreview";
import { useAppContext } from "../../contexts/appContext";
const BannerCreationModal = ({ showModal, setRefetch, setShowModal }) => {
  const { Dragger } = Upload;
  const formRef = useRef();

  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const { startLoading, stopLoading } = useAppContext();

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handleUploadChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const onSubmitForm = () => {
    formRef.current.submit();
  };

  const onCancelForm = () => {
    formRef.current.resetFields();
    setShowModal(false);
  };
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleAddBanner = () => {
    const files = fileList[0].originFileObj;
    startLoading();
    uploadBanner(files)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Product Successfully Added",
        });
        setShowModal(false);
        formRef.current.resetFields();
        setRefetch(true);
      })
      .finally(() => {
        stopLoading();
      });
  };
  return (
    <CustomModal
      title="Add Banner"
      open={showModal}
      onClose={onCancelForm}
      onCancel={onCancelForm}
      footer={[
        <StyledButton
          key="cancel"
          onClick={onCancelForm}
          background="white"
          color="black"
        >
          Cancel
        </StyledButton>,
        <StyledButton key={"submit"} onClick={onSubmitForm}>
          Save
        </StyledButton>,
      ]}
    >
      <Divider className="mt-0" />
      <Form ref={formRef} onFinish={handleAddBanner} layout="vertical">
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="banner">
              <Dragger
                listType="picture"
                beforeUpload={() => false}
                multiple={false}
                fileList={fileList}
                onChange={handleUploadChange}
                onPreview={handlePreview}
                accept=".png,.jpg,.jpeg"
                maxCount={1}
              >
                <div className="flex justify-center">
                  <PiUploadSimpleLight size={40} />
                </div>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single or bulk upload. Strictly prohibited from
                  uploading company data or other banned files.
                </p>
              </Dragger>
              {previewOpen && (
                <ImagePreview
                  previewOpen={previewOpen}
                  previewImage={previewImage}
                  setPreviewOpen={setPreviewOpen}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomModal>
  );
};
export default BannerCreationModal;
